import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-360283af"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  href: "#howItWorks",
  class: "custom-link"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"secondary-btn responsive box\" data-v-360283af> Learn More <div class=\"download-svg-arrow\" data-v-360283af><svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-360283af><path d=\"M14 8.77502L8.66667 14.775L7.33333 14.775L2 8.77502\" stroke=\"#00FFE0\" stroke-miterlimit=\"10\" data-v-360283af></path><path d=\"M8 14.775L8 2.77502\" stroke=\"#00FFE0\" stroke-miterlimit=\"10\" data-v-360283af></path></svg></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, _hoisted_3))
}